module.exports = __webpack_public_path__ + "88d8c74172c4826b3a50cb5911b8874a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/GC_BIERKIRCHE.jpg
// module id = 884
// module chunks = 0